import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { IpdProjectPagedResultVO } from '../types/ipdProject';

export const ipdProjectApi = {
  getList: async (params?: {
    pageNum?: number;
    pageSize?: number;
    keyword?: string;
    brand?: string;
    status?: string;
  }): Promise<IpdProjectPagedResultVO> => {
    const queryParams = new URLSearchParams();
    if (params?.pageNum) queryParams.append('pageNum', params.pageNum.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params?.keyword) queryParams.append('keyword', params.keyword);
    if (params?.brand) queryParams.append('brand', params.brand);
    if (params?.status) queryParams.append('status', params.status);

    const response = await fetch(`${API_ENDPOINTS.IPD_PROJECTS.LIST}?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    return handleResponse<IpdProjectPagedResultVO>(response);
  },
};
